



































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import VWidget from '@/components/VWidget.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import Projection from '@/store/entities/casis/projection';

class PageProjectionRequest {
    year: any = parseInt(Util.abp.clock.today().substr(0, 4));
}

@Component({
    components: { VWidget },
})

export default class ProjectionForm extends ListBase {
    pagerequest: PageProjectionRequest = new PageProjectionRequest();
    listValues: Array<any> = new Array<any>();
    totals: Array<any> = new Array<any>();
    
    /***** computed methods *****/

    get loading() {
        return this.$store.state.projection.loading;
    }

    get list() {
        return this.$store.state.projection.list;
    }

    get periods() {
        return this.gCommonList('years');
    }

    get months() {
        let list = this.gCommonList('months');
        list.forEach(m => {
            m['field'] = 'month_' + m.id;
        });
        return list;
    }

    get groups() {
        let list = Util.abp.list.getList('G_FIGURE');
        list.forEach(item => {
            if (item.code == 'TA') item.subtotal = 4;
            if (item.code == 'VE') item.subtotal = 9;
            if (item.code == 'IN') item.subtotal = 21;
            if (item.code == 'HO') item.subtotal = 26;
        });
        
        return list;
    }
    
    get projection() {
        if (this.list[0] == undefined) return null;
        if (this.list[0].projection_id == null) return null;
        return {
            id: this.list[0].projection_id,
            month: this.list[0].projection_month,
            state: this.list[0].projection_state,
            published: this.list[0].projection_published,
        };
    }
    
    get state() {
        if (this.projection == null) return Util.abp.list.get('E_FIGURE','DI');
        return Util.abp.list.getItem(this.projection.state);
    }

    get checking() {
        return this.$store.state.dashboard.loading;
    }

    get isAdmin() {
        return Util.abp.session.isAdmin;
    }
    
    get isDealer() {
        return Util.abp.session.isDealer();
    }

    /***** fields events *****/
    columns(group: string) {
        let cols = [{ value: 'concept_name', text: group.toUpperCase(), type: 'text', sortable: false, align: 'start', width: '280px', class: '' }];

        this.months.forEach(m => {
            let cClass = (this.projection != null && m.field == ('month_' + this.projection.month) ? 'selected-month' : '');
            if (this.projection != null && this.projection.published && this.projection.month == 12) cClass = '';
            cols.push({ value: m.field, text: m.name, type: 'text', width: '82px', sortable: false, align: 'center', class: cClass });
        });
        cols.push({ value: 'total', text: 'TOTAL', type: 'text', width: '65px', sortable: false, align: 'center', class: '' });
        return cols;
    }
    
    setList() {
        this.listValues = [];
        this.groups.forEach(gru => {
            let subTotal = { concept_name: 'Sub Total', number: null, total: 0 };

            this.listValues[gru.id] = [];

            this.list.forEach(item => {
                if (item.group_id == gru.id) {
                    this.listValues[gru.id].push(item);

                    if (subTotal != null && item.number <= gru.subtotal) {
                        this.months.forEach(m => {
                            if (subTotal[m.field] == undefined && item[m.field] != undefined) subTotal[m.field] = 0;
                            if (item[m.field] != undefined) {
                                subTotal[m.field] += item[m.field];
                                subTotal.total += item[m.field];
                            }
                        });

                        if (subTotal != null && item.number == gru.subtotal)
                            this.listValues[gru.id].push(subTotal);
                    }
                }
            });
        });            
    }

    updateTotal(item) {
        item.total = 0;
        this.months.forEach(m => {
            item.total += (item[m.field] == null || item[m.field] == '' ? 0 : parseFloat(item[m.field]));
        });
        this.setTotals();
    }

    setTotals() {
        this.totals = [];
        this.groups.forEach(gru => {
            this.totals[gru.id] = {total: 0};

            this.months.forEach(m => {
                this.totals[gru.id][m.field] = 0;
            });

            if (this.listValues[gru.id] != undefined) {
                this.listValues[gru.id].forEach(item => {
                    this.months.forEach(m => {
                        if (item.number != null)
                            this.totals[gru.id][m.field] += parseFloat((item[m.field] != undefined && item[m.field] != '' ? item[m.field] : 0));
                    });
                });

                this.months.forEach(m => {
                    this.totals[gru.id][m.field] = parseFloat(this.totals[gru.id][m.field].toFixed(2));
                    this.totals[gru.id].total += this.totals[gru.id][m.field];
                });
            }

            this.totals[gru.id].total = parseFloat(this.totals[gru.id].total.toFixed(2));
        });
    }

    onFocus(e) {
        e.target.select();
    }
            
    async exportData() {
        let filename = await this.$store.dispatch({
            type: 'projection/export',
            data: this.pagerequest
        });
        if (filename != '' && filename != undefined)
            window.location = filename;
    }

    async create() {
        this.$swal({
            title: '&iquest;Est&aacute; seguro?',
            html: 'Se procesara el calculo de proyecciones',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, &iexcl;Procesar!',
            cancelButtonText: '&iexcl;No!',
            showCloseButton: true,
            showLoaderOnConfirm: true
        }).then(async (result) => {
            if (result.value) {
                await this.$store.dispatch({
                    type: 'projection/create',
                    data: {
                        year: this.pagerequest.year
                    }
                });
                await this.loadData();
            }
        })
    }

    async loadData() {
        await this.$store.dispatch({
            type: 'projection/getAll',
            data: this.pagerequest
        });
        this.setList();
        this.setTotals();
    }
                        
    async mounted() {
        await this.loadData();
    }

    created() {
    }
}
